import { EmailParticipantsAPI } from '@/src/api';
import { useApiClient } from '@/src/hooks/api/useApiClient';
import { useTranslation } from 'react-i18next';

export const useEmailParticipantsAPI = () => {
  const { t } = useTranslation();

  return new EmailParticipantsAPI(useApiClient(), t);
};
